import { cn } from '@latitude/token-utils';
import { Command as CommandPrimitive } from 'cmdk';
import type { ComponentPropsWithoutRef, ComponentRef, Ref } from 'react';

export const CommandGroup = ({
  className,
  heading,
  ref,
  ...props
}: ComponentPropsWithoutRef<typeof CommandPrimitive.Group> & {
  ref?: Ref<ComponentRef<typeof CommandPrimitive.Group>>;
}) => {
  return (
    <CommandPrimitive.Group
      ref={ref}
      heading={heading}
      {...(heading && { 'data-testid': `action-list-group-${heading}` })}
      className={cn(
        '[&_[cmdk-separator]]:mb-spacing-comp-popover-gap [&_.action-list-item:not(:last-child)]:mb-spacing-comp-popover-gap font-comp-action-list-small-font-family text-color-comp-action-list-strong-on-container-separator [&_[cmdk-group-heading]]:p-1 [&_[cmdk-group-heading]]:pl-2 text-font-comp-action-list-medium-font-size font-comp-action-list-medium-font-weight leading-font-comp-action-list-medium-line-height',
        className,
      )}
      {...props}
    />
  );
};

CommandGroup.displayName = CommandPrimitive.Group.displayName;
